import React from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import InviteeDataStep from './InviteeDataStep';

const Rsvp = ({ isArabic, token, inviteeData, setInviteeData }) => {
  
  const validationSchema = Yup.object({
    personComing: Yup.boolean().required('Attendance status is required'),
    partnerComing: Yup.boolean().notRequired(),
  });

  // Determine initial values based on the `status` from inviteeData
  const initialValues = {
    personComing: inviteeData?.status === 1 || inviteeData?.status === 2, // true if person is coming
    partnerComing: inviteeData?.status === 1 || inviteeData?.status === 3, // true if partner is coming
    plusOnes: inviteeData?.plusOnes || {},
    message: inviteeData?.wishNote || '',
    plusOneCount: Object.values(inviteeData?.plusOnes || {}).filter((plusOne) => plusOne.status === 1).length,
  };

  const submitRsvp = async (values, { setSubmitting }) => {
    try {
      // Determine the correct status based on the combination of person and partner attendance
      let status;
      if (values.personComing && values.partnerComing) {
        status = 1; // Both coming
      } else if (values.personComing && !values.partnerComing) {
        status = 2; // Person coming, partner not
      } else if (!values.personComing && values.partnerComing) {
        status = 3; // Partner coming, person not
      } else {
        status = 4; // Neither coming
      }

      const updatedPlusOnes = Object.keys(values.plusOnes).reduce((acc, key) => {
        acc[key] = {
          name: values.plusOnes[key].name || inviteeData.plusOnes[key]?.name,
          status: values.plusOnes[key].status,
        };
        return acc;
      }, {});

      const updatedData = {
        clientKey: inviteeData.clientKey,
        status,
        plusOnes: updatedPlusOnes,
        wishNote: values.message,
      };

      const response = await fetch('https://flokisoft.com/youssefandlara/updater', {
        method: 'POST',
        headers: {
          Authorization: 'ZPJTjkUuhg%',
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedData),
      });

      if (response.ok) {
        alert('RSVP submitted successfully!');
      } else {
        alert('Error submitting RSVP.');
      }

      setSubmitting(false);
    } catch (error) {
      console.error('Error submitting RSVP:', error);
      setSubmitting(false);
    }
  };

  if (inviteeData === null) {
    return '';
  } else {
    return (
      <div dir={isArabic ? 'rtl' : 'ltr'} className="rsvp-form h-full w-[90%]  mx-auto  md:w-full max-w-2xl p-6  bg-textgold bg-opacity-40 rounded-lg shadow-md">
        {inviteeData ? (
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={submitRsvp}
            enableReinitialize
          >
            {({ values, isSubmitting, setFieldValue }) => (
              <Form>
                <InviteeDataStep
                  inviteeData={inviteeData}
                  isArabic={isArabic}
                  isSubmitting={isSubmitting}
                  setFieldValue={setFieldValue}
                  values={values}
                />
              </Form>
            )}
          </Formik>
        ) : (
          <p>Loading invitee data...</p>
        )}
      </div>
    );
  }
};

export default Rsvp;
